import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: {
        "max-width": "1100",
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
        persistent: "",
        scrollable: "",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        VCard,
        [
          _c(
            VCardTitle,
            { staticClass: "d-flex justify-space-between" },
            [
              _c("div", { staticClass: "text-subtitle-1" }, [
                _vm._v(" Please confirm "),
                _c("div", { staticClass: "text-caption font-weight-light" }, [
                  _vm._v(
                    " These reports sit on a lot their worksheet number or document disagrees with (" +
                      _vm._s(_vm.startDate) +
                      " to " +
                      _vm._s(_vm.endDate) +
                      "). Auto-assign left them for you. "
                  ),
                ]),
              ]),
              _c(
                VBtn,
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c(VIcon, [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(VDivider),
          _c(
            VCardText,
            { staticClass: "pt-3" },
            [
              _vm.loading
                ? _c(VProgressLinear, {
                    staticClass: "mb-3",
                    attrs: { indeterminate: "" },
                  })
                : _vm.loadFailed
                ? _c(
                    "div",
                    { staticClass: "text-body-2 my-4" },
                    [
                      _vm._v(" Could not load the list. "),
                      _c(
                        VBtn,
                        {
                          attrs: { small: "", text: "", color: "primary" },
                          on: { click: _vm.load },
                        },
                        [_vm._v("Retry")]
                      ),
                    ],
                    1
                  )
                : _vm.rows.length === 0
                ? _c("div", { staticClass: "text-body-2 my-4" }, [
                    _vm._v("Nothing left to confirm."),
                  ])
                : _vm._e(),
              _vm._l(_vm.rows, function (row) {
                return _c(
                  VCard,
                  {
                    key: row.result.id,
                    staticClass: "mb-3 pa-3",
                    attrs: { outlined: "" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-wrap align-center" },
                      [
                        _c("div", { staticClass: "flex-grow-1 mr-4" }, [
                          _c("div", { staticClass: "font-weight-medium" }, [
                            _vm._v(
                              " " +
                                _vm._s(row.result.sampleName) +
                                " · " +
                                _vm._s(row.result.averoutN) +
                                " "
                            ),
                            _c(
                              "span",
                              { staticClass: "text-caption grey--text ml-2" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDateTime")(
                                      row.result.testTime
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-caption orange--text text--darken-3",
                            },
                            [_vm._v(_vm._s(row.result.lotCheck))]
                          ),
                          _c("div", { staticClass: "text-caption" }, [
                            _vm._v(
                              " Now on lot " +
                                _vm._s(row.result.inventoryId) +
                                " "
                            ),
                            row.suggested
                              ? _c("span", [
                                  _vm._v(
                                    " · suggested lot " +
                                      _vm._s(row.suggested.inventoryId) +
                                      " "
                                  ),
                                  row.suggested.documentNumber
                                    ? _c("span", [
                                        _vm._v(
                                          "(" +
                                            _vm._s(
                                              row.suggested.documentNumber
                                            ) +
                                            ")"
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "d-flex flex-wrap" },
                          [
                            _c(
                              VBtn,
                              {
                                staticClass: "ma-1",
                                attrs: {
                                  small: "",
                                  color: "primary",
                                  disabled: !row.suggested || row.busy,
                                  loading: row.busy === "use",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.useSuggested(row)
                                  },
                                },
                              },
                              [_vm._v("Use suggested")]
                            ),
                            _c(
                              VBtn,
                              {
                                staticClass: "ma-1",
                                attrs: {
                                  small: "",
                                  outlined: "",
                                  disabled: !!row.busy,
                                  loading: row.busy === "keep",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.keepCurrent(row)
                                  },
                                },
                              },
                              [_vm._v("Keep current")]
                            ),
                            _c(
                              VBtn,
                              {
                                staticClass: "ma-1",
                                attrs: {
                                  small: "",
                                  outlined: "",
                                  disabled: !!row.busy,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.chooseOther(row)
                                  },
                                },
                              },
                              [_vm._v("Choose another…")]
                            ),
                            _c(
                              VBtn,
                              {
                                staticClass: "ma-1",
                                attrs: {
                                  small: "",
                                  text: "",
                                  disabled: !!row.busy,
                                  loading: row.busy === "none",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.leaveUnassigned(row)
                                  },
                                },
                              },
                              [_vm._v("Leave unassigned")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
          _c(
            VCardActions,
            [
              _vm.total > 0
                ? _c("span", { staticClass: "text-caption grey--text ml-2" }, [
                    _vm._v(" " + _vm._s(_vm.remaining) + " to confirm"),
                    _vm.total > _vm.loaded
                      ? _c("span", [
                          _vm._v(
                            " · showing " + _vm._s(_vm.loaded) + " at a time"
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _c(VSpacer),
              _c(VBtn, { attrs: { text: "" }, on: { click: _vm.close } }, [
                _vm._v("Later"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("lab-result-lot-chooser", {
        attrs: {
          activated: _vm.chooserOpen,
          "lab-result": _vm.chooserRow ? _vm.chooserRow.result : null,
        },
        on: {
          "update:activated": function ($event) {
            _vm.chooserOpen = $event
          },
          chosen: (id) => _vm.decided(_vm.chooserRow, id, "use"),
          unassign: function ($event) {
            return _vm.decided(_vm.chooserRow, null, "none")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }